import { FETCH_TRANSACTIONS } from './actionTypes';


export const fetchTransactions = (
    params={tenantId:"", startDate:null, endDate:null}
) => {
    return ({
        type: FETCH_TRANSACTIONS,
        payload: {
            ...params
        }
    })
}